import { render, staticRenderFns } from "./sugestao-reposicao.vue?vue&type=template&id=1633488d&scoped=true&"
import script from "./sugestao-reposicao.vue?vue&type=script&lang=js&"
export * from "./sugestao-reposicao.vue?vue&type=script&lang=js&"
import style0 from "./sugestao-reposicao.vue?vue&type=style&index=0&id=1633488d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633488d",
  null
  
)

export default component.exports